import { Session } from '@ais-ui/auth';

import { AutoCompleteShipInfo, ExternalShipInfo } from '../autoCompleteShip';

export const autocompleteShips = async (
  session: Session,
  searchString: string
): Promise<AutoCompleteShipInfo[]> => {
  const response: ExternalShipInfo[] = await session.request(
    'autocompleteShips',
    {
      searchString: searchString,
    }
  );

  const result = response.map(
    ({ callSign, imo, mmsi, name, type, timedOut, filteredOut }) => ({
      callSign,
      imo,
      mmsi,
      name,
      type,
      filteredOut,
      timedOut,
    })
  );

  return result;
};
